// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1icp8","requiredAsterisk":"Info_requiredAsterisk__3ewc7"};